/**
 * FlagRoute — Route guard that redirects to `/` when a feature flag is OFF.
 *
 * Usage:
 *   <Route path="/truck/:id" element={<FlagRoute flag="truck_features"><FoodTruckDetail /></FlagRoute>} />
 *
 * While the flag snapshot is still loading, renders nothing (avoids a
 * flash of gated content).
 */
import { Navigate } from "react-router-dom";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

export default function FlagRoute({ flag, children, redirectTo = "/" }) {
  const { flags, loading } = useFeatureFlags();
  if (loading) return null;
  if (!flags[flag]) return <Navigate to={redirectTo} replace />;
  return children;
}
